var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightLong = function SvgArrowRightLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.257.714a.48.48 0 0 0-.353.817l3.83 3.99H.97a.48.48 0 0 0-.42.237.48.48 0 0 0 0 .484c.087.15.248.24.42.238h20.762l-3.828 3.988a.48.48 0 1 0 .693.664L23.526 6 18.598.868a.48.48 0 0 0-.34-.154"
  })));
};
export default SvgArrowRightLong;